import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {ConfigService} from './app/shared';

ConfigService.loadConfig().then(async () => {
  if (ConfigService.isProduction()) {
    enableProdMode();
  }
  try {
    return platformBrowserDynamic().bootstrapModule(AppModule);
  } catch (err) {
    return console.error(err);
  }
});
